import { gql } from "@apollo/client";
import {
  LayoutDeepNestingFragment,
  LayoutNodeDeepNestingFragment,
  LayoutNodeLinkDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNodeActionType,
  LayoutNodeFilterType,
  LayoutNodeType,
} from "@towersystems/roam-common/lib/generated-types";
import * as Yup from "yup";
import { TypeListItem } from "./types";

export const layoutNodeLinkInputSchema = Yup.object({
  url: Yup.string().required(),
  newTab: Yup.boolean().optional(),
});

export const layoutNodeFilterInputSchema = Yup.object({
  type: Yup.mixed<LayoutNodeFilterType>()
    .oneOf(Object.values(LayoutNodeFilterType))
    .required(),
  values: Yup.array(Yup.string().required()).min(1).required(),
});

export const baseNodeInputSchema = Yup.object({
  id: Yup.string().optional(),
  label: Yup.string().optional(),
  color: Yup.string().optional(),
  layoutId: Yup.string().optional(),
  productId: Yup.string().optional(),
  position: Yup.number().integer().optional(),
  showImage: Yup.boolean().optional(),
  type: Yup.string().optional(),
  action: Yup.string().optional(),
  link: layoutNodeLinkInputSchema.optional().default(undefined),
  filter: layoutNodeFilterInputSchema.optional().default(undefined),
});

export const productNodeInputSchema = baseNodeInputSchema.shape({
  productId: Yup.string().required(),
});

export const actionNodeInputSchema = baseNodeInputSchema.shape({
  action: Yup.string().required(),
  link: layoutNodeLinkInputSchema.optional().default(undefined),
});

export const filterNodeInputSchema = baseNodeInputSchema.shape({
  filter: layoutNodeFilterInputSchema.required(),
});

export const defaultLayoutNodeInputValues = {
  id: undefined,
  label: undefined,
  color: "#fff",
  layoutId: undefined,
  productId: undefined,
  position: undefined,
  showImage: undefined,
  type: undefined,
  action: undefined,
  link: undefined,
  filter: undefined,
  labelColor: "#262625",
  base64Image: undefined, //
};

export const LayoutScreens = {
  CreateQuickKeyRootScreen: "CreateQuickKeyRootScreen",
  CreateQuickKeyTypeListScreen: "CreateQuickKeyTypeListScreen",
  CreateCustomUrlQuickKeyScreen: "CreateCustomUrlQuickKeyScreen",
  CreateProductQuickKeyRootScreen: "CreateProductQuickKeyRootScreen",
  CreateFilterQuickKeyScreen: "CreateFilterQuickKeyScreen",
  CreateFilterQuickKeyRootScreen: "CreateFilterQuickKeyRootScreen",

  EditQuickKeyRootScreen: "EditQuickKeyRootScreen",
  EditActionQuickKeyScreen: "EditActionQuickKeyScreen",
  EditProductQuickScreen: "EditProductQuickKeyRootScreen",
  EditFilterQuickKeyRootScreen: "EditFilterQuickKeyRootScreen",

  CategoryListScreen: "CategoryListScreen",
  DepartmentListScreen: "DepartmentListScreen",
} as const;

export enum LayoutNodeActionFormVariants {
  Create = "Create",
  Edit = "Edit",
}

export const ChangePageBarVariant = {
  Left: "Left",
  Right: "Right",
  Add: "Add",
  Remove: "Remove",
} as const;

export const QUERY_LAYOUT_BY_TERMINAL_ID = gql`
  ${LayoutDeepNestingFragment}
  ${LayoutNodeDeepNestingFragment}
  ${LayoutNodeLinkDeepNestingFragment}
  query layoutByTerminalId($id: ID!) {
    layoutByTerminalId(id: $id) {
      ...LayoutDeepNesting
    }
  }
`;

export const posLayoutResetSuccessMessage = {
  message: "Successfully reset POS layout",
  severity: "success" as const,
};

export const posLayoutResetFailureMessage = {
  message: "Failed to reset POS layout",
  severity: "error" as const,
};

export const MAX_LAYOUT_ROWS = 4;

export const defaultShiftParams = {
  start: 0,
  end: 0,
  offset: 0,
  target: undefined,
};

export const HOMING_ANIMATION_DURATION = 400;

export const DEFAULT_HOMING_POINT = {
  x: 0,
  y: 0,
};

export const quickKeyTypesWithForm: TypeListItem[] = [
  LayoutNodeType.PRODUCT,
  LayoutNodeType.FILTER,
  ...Object.values(LayoutNodeFilterType),
];
